import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import EditWaForm from '../../pages/wa-forms/edit';
import WaFormResponses from '../../pages/wa-forms/responses';

const List = lazy(() => import('../../pages/wa-forms/forms-list'));
const CreateFrom = lazy(() => import('../../pages/wa-forms/create'));
function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`} component={List} />
            <Route path={`${path}/create`} component={CreateFrom} />
            <Route path={`${path}/edit/:uuid`} component={EditWaForm} />
            <Route path={`${path}/responses/:uuid`} component={WaFormResponses} />
            {/* <Route path={`${path}`} component={Users} /> */}
        </Switch>
    );
}

export default PagesRoute;

